import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge has to be told about the custom scales in `styles/index.css`,
 * because they are named by role rather than by size and it would otherwise
 * guess wrong in two ways:
 *
 *  - The type scale (`text-body`, `text-hint`, …) looks like a text *colour* to
 *    it, so a size next to a colour was silently dropped: `cn('text-hint
 *    text-fg-hint')` resolved to just `text-fg-hint`.
 *  - The radius and shadow scales are unknown, so two of them did not conflict
 *    at all and the stylesheet order decided the winner instead of the caller.
 */
const FONT_SIZE_TOKENS = [
  'band',
  'tab',
  'meta',
  'duration',
  'hint',
  'chip',
  'label',
  'control',
  'body',
  'row',
  'action',
  'card',
  'month',
  'screen',
  'donut',
] as const;

const RADIUS_TOKENS = ['cell', 'chip', 'badge', 'control', 'card', 'panel', 'alert', 'sheet'] as const;

const SHADOW_TOKENS = ['card', 'dialog', 'pill', 'thumb', 'knob'] as const;

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [...FONT_SIZE_TOKENS] }],
      rounded: [{ rounded: [...RADIUS_TOKENS] }],
      shadow: [{ shadow: [...SHADOW_TOKENS] }],
    },
  },
});

/** Conditional class names with later Tailwind utilities winning. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
